import { createFileRoute } from "@tanstack/react-router";
import { assertPagePermission } from "@/features/auth/lib/assert-page-permission";
import { pageStateQueryOptions, PageAccessError } from "@/lib/queries";
import { PageError } from "@/features/auth/components/PageError";
import { usePageState } from "@/hooks/usePageState";
import { DrilldownPage } from "@/features/drilldown/components/DrilldownPage";
import { normalizeExploreSearchInput } from "@/features/dashboard/lib/explore-search";
import { drilldownSearchSchema } from "@/features/drilldown/lib/drilldown-search";

function DrilldownRoute() {
  const { isLoading, error } = usePageState("drilldown");
  if (isLoading) return null;
  if (error) return <PageError is403={error instanceof PageAccessError} />;
  return <DrilldownPage />;
}

export const Route = createFileRoute("/_authenticated/drilldown")({
  beforeLoad: () => assertPagePermission("drilldown"),
  validateSearch: (search: Record<string, unknown>) =>
    drilldownSearchSchema.parse(normalizeExploreSearchInput(search)),
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData(pageStateQueryOptions("drilldown"))
      .catch((err: unknown) => {
        if (err instanceof PageAccessError) return null;
        throw err;
      }),
  component: DrilldownRoute,
  errorComponent: ({ error }) => (
    <PageError is403={error instanceof PageAccessError} />
  ),
});
